'use es6';

import { BUTTON_DEFAULT_BACKGROUND_COLOR_CHANGE, BUTTON_DEFAULT_CORNER_RADIUS_CHANGE, BUTTON_DEFAULT_FONT_CHANGE, DIVIDER_DEFAULT_HEIGHT_CHANGE, DIVIDER_DEFAULT_COLOR_CHANGE, DIVIDER_DEFAULT_LINE_TYPE_CHANGE, FONT_DEFAULT_CHANGE, UPDATE_TEMPLATE_SETTING, UPDATE_LINKS_FONT_STYLE, UPDATE_BOXED, UPDATE_LAYOUT_PADDING, UPDATE_MOBILE_LAYOUT_PADDING, INHERIT_DEFAULT_STYLE_SETTINGS } from 'EmailEditorUI/redux/actions/IframeSyncedActionTypes';
import { getSections } from 'EmailEditorUI/redux/selectors/sectionSelectors';
import { getModuleSpec } from 'EmailEditorUI/redux/selectors/ModuleSelectors';
import { getEffectiveStyleSettings } from 'EmailEditorUI/redux/selectors/styleSettingsSelectors';
import { maybePrependStyleGroup } from 'EmailEditorUI/constants/StyleFieldsMigration';
import { MODULE_TYPES, getModuleId } from 'EmailData/constants/DefaultModulesConstants';
const {
  BUTTON,
  DIVIDER,
  FOOTER,
  WEB_VERSION_LINK,
  FOLLOW_ME,
  EMAIL_PRODUCTS,
  EMAIL_ABANDONED_CART,
  EMAIL_CART
} = MODULE_TYPES;
export function updateSetting(setting, newValue, {
  isEditingForAllDevices = true
} = {}) {
  return (dispatch, getState) => {
    const path = Array.isArray(setting) ? setting : [setting];
    const defaultValue = getEffectiveStyleSettings(getState()).getIn(path);
    dispatch({
      type: UPDATE_TEMPLATE_SETTING,
      setting,
      newValue,
      defaultValue,
      isEditingForAllDevices,
      undoData: {
        groupKey: 'template_settings'
      }
    });
  };
}
export function updateLayoutPadding({
  top,
  bottom
}) {
  return {
    type: UPDATE_LAYOUT_PADDING,
    layoutPadding: {
      top,
      bottom
    },
    undoData: {
      groupKey: 'template_settings'
    }
  };
}
export function updateMobileLayoutPadding(enable) {
  return {
    type: UPDATE_MOBILE_LAYOUT_PADDING,
    enable,
    undoData: {
      groupKey: 'template_settings'
    }
  };
}
export function updateLinksFontStyle(value) {
  return {
    type: UPDATE_LINKS_FONT_STYLE,
    value,
    undoData: {
      groupKey: 'template_settings'
    }
  };
}
export function updateBoxed(isBoxed) {
  return (dispatch, getState) => {
    const state = getState();
    const numSections = getSections(state).size;
    dispatch({
      type: UPDATE_BOXED,
      isBoxed,
      numSections
    });
  };
}
export function inheritDefaultStyleSettings() {
  return {
    type: INHERIT_DEFAULT_STYLE_SETTINGS,
    undoData: {
      groupKey: 'template_settings'
    }
  };
}

// MODULE DEFAULTS

const makeModuleDefaultChangeThunk = (actionType, affectedModules, isFontStyle = false) => (newValue, prevValue) => (dispatch, getState) => {
  affectedModules.forEach(affectedModule => {
    const [moduleType, fieldName, styleFieldName] = affectedModule;
    const moduleId = getModuleId(moduleType);
    const moduleSpec = getModuleSpec(getState(), moduleId);
    dispatch({
      type: actionType,
      isModuleDefaultsChange: true,
      affectedModuleId: moduleId,
      newValue,
      prevValue,
      fieldName: maybePrependStyleGroup(moduleSpec, fieldName, styleFieldName),
      isFontStyle,
      undoData: {
        groupKey: 'template_settings'
      }
    });
  });
};
export const buttonDefaultBackgroundColorChange = makeModuleDefaultChangeThunk(BUTTON_DEFAULT_BACKGROUND_COLOR_CHANGE, [[BUTTON, 'background_color', ['style', 'background_color', 'color']], [EMAIL_PRODUCTS, ['button_styles', 'background_color'], ['style', 'background_color', 'color']], [EMAIL_ABANDONED_CART, ['button_styles', 'background_color'], ['style', 'background_color', 'color']], [EMAIL_CART, ['button_styles', 'background_color'], ['style', 'background_color', 'color']]]);
export const buttonDefaultCornerRadiusChange = makeModuleDefaultChangeThunk(BUTTON_DEFAULT_CORNER_RADIUS_CHANGE, [[BUTTON, 'corner_radius'], [EMAIL_PRODUCTS, ['button_styles', 'corner_radius']], [EMAIL_ABANDONED_CART, ['button_styles', 'corner_radius']], [EMAIL_CART, ['button_styles', 'corner_radius']]]);
export const buttonDefaultFontChange = makeModuleDefaultChangeThunk(BUTTON_DEFAULT_FONT_CHANGE, [[BUTTON, 'font_style'], [EMAIL_PRODUCTS, ['button_styles', 'font_style']], [EMAIL_ABANDONED_CART, ['button_styles', 'font_style']], [EMAIL_CART, ['button_styles', 'font_style']]], true);
export const dividerDefaultHeightChange = makeModuleDefaultChangeThunk(DIVIDER_DEFAULT_HEIGHT_CHANGE, [[DIVIDER, 'height'], [EMAIL_PRODUCTS, ['divider_styles', 'height']], [EMAIL_CART, ['divider_styles', 'height']]]);
export const dividerDefaultColorChange = makeModuleDefaultChangeThunk(DIVIDER_DEFAULT_COLOR_CHANGE, [[DIVIDER, 'color'], [EMAIL_PRODUCTS, ['divider_styles', 'color']], [EMAIL_CART, ['divider_styles', 'color']]]);
export const dividerDefaultLineTypeChange = makeModuleDefaultChangeThunk(DIVIDER_DEFAULT_LINE_TYPE_CHANGE, [[DIVIDER, 'line_type'], [EMAIL_PRODUCTS, ['divider_styles', 'line_type']], [EMAIL_CART, ['divider_styles', 'line_type']]]);
export const modulesLinkDefaultChange = makeModuleDefaultChangeThunk(FONT_DEFAULT_CHANGE, [[FOOTER, 'link_font'], [WEB_VERSION_LINK, 'font'], [FOLLOW_ME, 'font_style']], true);
export const modulesChangePrimaryFontDefault = makeModuleDefaultChangeThunk(FONT_DEFAULT_CHANGE, [[EMAIL_PRODUCTS, ['font_styles', 'description_font_style']], [EMAIL_PRODUCTS, ['font_styles', 'price_font_style']], [EMAIL_ABANDONED_CART, ['font_styles', 'description_font_style']], [EMAIL_ABANDONED_CART, ['font_styles', 'price_font_style']], [EMAIL_ABANDONED_CART, ['font_styles', 'quantity_font_style']], [EMAIL_CART, ['font_styles', 'description_font_style']], [EMAIL_CART, ['font_styles', 'price_font_style']], [EMAIL_CART, ['font_styles', 'quantity_font_style']]], true);
export const modulesChangeHeadingTwoFontDefault = makeModuleDefaultChangeThunk(FONT_DEFAULT_CHANGE, [[EMAIL_PRODUCTS, ['font_styles', 'product_name_font_style']], [EMAIL_ABANDONED_CART, ['font_styles', 'product_name_font_style']], [EMAIL_CART, ['font_styles', 'product_name_font_style']]], true);